"use client";

import * as React from "react";

// Clean Label component without external dependencies
function Label({
  className = "",
  ...props
}: React.LabelHTMLAttributes<HTMLLabelElement>) {
  const baseClasses = "flex items-center gap-2 text-sm leading-none font-medium select-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50";
  
  return (
    <label
      className={`${baseClasses} ${className}`}
      {...props}
    />
  );
}

export { Label };